<template>
    <modalComponent show="show" modalLarge="true">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title m-0" id="exampleModalDefaultLabel">Time Slots</h6>
                <button type="button" class="close" v-on:click="close()"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <div class="form-group ">
                    <label>Days</label>
                    <multiselect v-model="slots.day" :options="['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']" :disabled="slots.id != '00000000-0000-0000-0000-000000000000'"  :show-labels="false" :placeholder="'Select Days'" :multiple="true">
                    </multiselect>
                </div>
                <div class="form-group ">
                    <label>Timing Slot Duration</label>
                    <select class="select form-control" v-model="slots.duration" :disabled="slots.id != '00000000-0000-0000-0000-000000000000'"> 
                        <option selected>Select Duration</option>
                        <option value="15">15 mins</option>
                        <option value="30">30 mins</option>
                        <option value="45">45 mins</option>
                        <option value="60">1 Hour</option>
                    </select>
                </div>
                <div class="form-group ">
                    <label>Start Time</label>
                    <input type="time" class="form-control" v-model="slots.startTime" :disabled="slots.id != '00000000-0000-0000-0000-000000000000'">
                </div>
                <div class="form-group ">
                    <label>End Time</label>
                    <input type="time" class="form-control" v-model="slots.endTime" :disabled="slots.id != '00000000-0000-0000-0000-000000000000'">
                </div>
                <div class="form-group ">
                    <label>Total Days</label>
                    <input type="number" class="form-control" v-model="slots.totalDays" :disabled="slots.id != '00000000-0000-0000-0000-000000000000'">
                </div>
                <div class="form-group ">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" name="checkbox" v-model="slots.isActive"> Active
                        </label>
                    </div>
                </div>
                <div class="submit-section text-center">
                    <button type="submit" class="btn btn-primary submit-btn" @click="SaveSlots()">Submit</button>
                    <button type="button" class="btn btn-secondary submit-btn" v-on:click="close()">Cancel</button>
                </div>
            </div>

            <loading v-model:active="loading" :can-cancel="false" :is-full-page="true"></loading>
        </div>
    </modalComponent>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import useVuelidate from '@vuelidate/core';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from "moment";
export default {
    name :"doctorAddSlotsModel",
    props: ['show', 'slotsModel', 'type'],
    components: {
        Loading,
        Multiselect
    },
    setup() {
        return { v$: useVuelidate() }
    },
    data: function () {
        return {

            render: 0,
            loading: false,
            slots: this.slotsModel,
            startTime: "",
            endTime: "",
        }
    },
    validations() {
        return {

        }
    },
    methods: {
        close: function () {
            this.$emit('close');
        },
        SaveSlots: function () {
            var root = this;
            this.loading = true;
            var token = '';
            if (token == '') {
                token = localStorage.getItem('token');
            }

            if (this.slots.id != '00000000-0000-0000-0000-000000000000')
            {
                this.slots.startTime = this.startTime+this.slots.startTime+":00";
                this.slots.endTime = this.endTime+this.slots.endTime+":00";
            }

            this.$https.post('/Slots/SaveSlots', this.slots, { headers: { "Authorization": `Bearer ${token}` } })
                .then(function (response) {
                    if (response.data.isSuccess == true) {
                        root.$swal.fire({
                            title: 'Saved',
                            text: response.data.commonMessage,
                            type: 'success',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });

                        root.close();

                    }
                    else {
                        root.$swal.fire({
                            title: 'Error!',
                            text: response.data.commonMessage,
                            type: 'error',
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                    root.$swal.fire(
                        {
                            icon: 'error',
                            title: 'Something Went Wrong!',
                            text: error.response.data,

                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });

                    root.loading = false
                })
                .finally(() => root.loading = false);
        }
    },
    mounted: function () {
        if (this.slots.id == '00000000-0000-0000-0000-000000000000') {
            this.slots.doctorId = localStorage.getItem("UserID");
        }
        if (this.slots.id != '00000000-0000-0000-0000-000000000000') {
            var days = [];
            this.slots.day.forEach(x => {
                if(x == 0)
                    days.push("Sunday");
                else if(x == 1)
                    days.push("Monday");
                else if(x == 2)
                    days.push("Tuesday");
                else if(x == 3)
                    days.push("Wednesday");
                else if(x == 4)
                    days.push("Thursday");
                else if(x == 5)
                    days.push("Friday");
                else if(x == 6)
                    days.push("Saturday");
            });
            this.slots.day = days;
            this.startTime = this.slots.startTime.substring(0, 11);
            this.endTime = this.slots.endTime.substring(0, 11);
            this.slots.startTime = moment(this.slots.startTime).format('HH:mm');
            this.slots.endTime = moment(this.slots.endTime).format('HH:mm');
        }
    }
}
</script>